module.exports = __webpack_public_path__ + "static/img/bg-match2.72b90e7f.png";